import {
  Button,
  EmptyState,
  Flex,
  Heading,
  InfoIcon,
} from '@buffer-mono/popcorn'

import styles from './CommentsError.module.css'

import type { JSX } from 'react'

interface CommentsErrorProps {
  errorMessage: string | null
  onRetry: () => Promise<void>
}

export function CommentsError({
  errorMessage,
  onRetry,
}: CommentsErrorProps): JSX.Element {
  const message = getErrorMessage(errorMessage)

  return (
    <EmptyState size="xlarge" variant="warning" className={styles.emptyState}>
      <EmptyState.Icon>
        <InfoIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        <Flex direction="column" gap="2xs" align="center">
          <Heading as="h3">{message.header}</Heading>
        </Flex>
      </EmptyState.Heading>
      <EmptyState.Description>{message.description}</EmptyState.Description>
      {message.canRetry && (
        <EmptyState.Actions>
          <Button size="large" onClick={onRetry}>
            Retry
          </Button>
        </EmptyState.Actions>
      )}
    </EmptyState>
  )
}

const getErrorMessage = (
  errorMessage: string | null,
): { header: string; description: string; canRetry: boolean } => {
  if (
    errorMessage?.includes('Actor can not access the specified channels') ||
    errorMessage?.includes('Actor can not access the organization')
  ) {
    return {
      header: 'You Don’t Have Access to Community',
      description:
        'You don’t currently have the required permissions to view or respond to comments. To change this, ask your Admin to give you Full Posting or Admin access to each channel you’d like to access comments for.',
      canRetry: false,
    }
  }

  return {
    header: 'We are having trouble loading comments',
    description:
      'Please try again later or contact support if the problem persists',
    canRetry: true,
  }
}
